import { CustomTitleLabel } from "components/earning/CustomBaseComponments";
import React from "react";

const MultipleInputWithTitle = ({
  title,
  titleCustomClass,
  inputConfig = [], //[{setValue, per, unit, type,},...] 
  inputAreaCustomClass,
}) => {
  return <>
    <div>
      {title && <CustomTitleLabel title={title} className={titleCustomClass || ''}/>}
      <div className={`d-flex flex-column flex-gap-12 ${inputAreaCustomClass || ''}`}>
        {inputConfig?.map((input) => {
          const { type, customClass, per, unit, setValue, ...otherInputParam } = input
          return (
            <div className="flex-gap-12 d-flex">
              {per && <div className="help-message">{per}</div>}
              <input
                type={type || "text"}
                onChange={({ target }) => setValue(target.value)}
                className={`custom-markdown-area-title custom-markdown-area-title-short ${type === 'number' ? 'custom-number-input-short' : ''
                  } ${customClass || ''}`}
                {...otherInputParam}
              />
              {unit ? (
                <div className="section-short-description">{unit}</div>
              ) : null}
            </div>
          )
        })}
      </div>
    </div>
  </>
}


export default MultipleInputWithTitle;